import { render, staticRenderFns } from "./Fairs.vue?vue&type=template&id=59cc4e10&scoped=true&"
import script from "./Fairs.vue?vue&type=script&lang=js&"
export * from "./Fairs.vue?vue&type=script&lang=js&"
import style0 from "./Fairs.vue?vue&type=style&index=0&id=59cc4e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc4e10",
  null
  
)

export default component.exports